module.exports = __webpack_public_path__ + "static/media/firstmile.b26136d4.gif";